export const WEEKDAYS = [
  { value: '1', title: 'Monday' },
  { value: '2', title: 'Tuesday' },
  { value: '3', title: 'Wednesday' },
  { value: '4', title: 'Thursday' },
  { value: '5', title: 'Friday' },
  { value: '6', title: 'Saturday' },
  { value: '7', title: 'Sunday' },
]

export const DEFAULT_ADMIN_QUICK_LINKS = [
  { enabled: true, name: 'Forms', icon: 'mdi-form-select', route: '/forms', color: '#00c0ef' },
  { enabled: true, name: 'Maintenance', icon: 'mdi-wrench', route: '/maintenance', color: '#00a65a' },
  { enabled: true, name: 'Safety', icon: 'mdi-shield-check', route: '/safety', color: '#f39c12' },
  { enabled: true, name: 'HR', icon: 'mdi-account-group', route: '/hr', color: '#dd4b39' },
]

export const DEFAULT_USER_DASHBOARD_LINKS = [
  { key: 'forms', enabled: true, name: 'Forms', icon: 'mdi-form-select', route: '/forms' },
  { key: 'safety', enabled: true, name: 'Safety', icon: 'mdi-shield-check', route: '/safety' },
  { key: 'maintenance', enabled: true, name: 'Maintenance', icon: 'mdi-wrench', route: '/maintenance' },
  { key: 'hr', enabled: true, name: 'HR', icon: 'mdi-account-group', route: '/hr' },
]

export const DEFAULT_REPORTS = [
  {
    id: 'user-list',
    name: 'User List',
    description: 'All employees with contact details',
    viewRoute: '/settings/reports/users',
  },
  {
    id: 'gear-list',
    name: 'Gear List',
    description: 'Inventory items with dimensions and quantities',
    viewRoute: '/settings/reports/inventory',
  },
]

const MANAGEMENT_ROUTES = new Set([
  '/settings',
  '/jobs',
  '/forms',
  '/forms/custom/build',
  '/forms/notifications',
  '/forms/submissions',
  '/maintenance',
  '/safety',
  '/hr',
  '/inventory',
  '/inventory/by-job',
  '/hours',
  '/hours/all-employees',
])

export const ADMIN_QUICK_LINK_OPTIONS = [
  { label: 'Settings', route: '/settings' },
  { label: 'Job Management', route: '/jobs' },
  { label: 'Forms Management', route: '/forms' },
  { label: 'Form Builder', route: '/forms/custom/build' },
  { label: 'Forms Notification Settings', route: '/forms/notifications' },
  { label: 'Maintenance Management', route: '/maintenance' },
  { label: 'Manuals Management', route: '/maintenance?tab=manuals' },
  { label: 'Safety Management', route: '/safety' },
  { label: 'HR Management', route: '/hr' },
  { label: 'User Accounts', route: '/settings?tab=accounts' },
  { label: 'Employees', route: '/hr?tab=employees' },
  { label: 'Inventory Management', route: '/inventory' },
  { label: 'View Inventory By Job', route: '/inventory/by-job' },
  { label: 'Submissions', route: '/forms/submissions' },
]

export const APP_LINK_GROUPS = [
  {
    label: 'General',
    items: [
      { label: 'Dashboard', route: '/dashboard' },
      { label: 'Settings', route: '/settings' },
      { label: 'Profile', route: '/profile' },
    ],
  },
  {
    label: 'Jobs',
    items: [{ label: 'Job Management', route: '/jobs' }],
  },
  {
    label: 'Forms',
    items: [
      { label: 'Forms Management', route: '/forms' },
      { label: 'Form Builder', route: '/forms/custom/build' },
      { label: 'Material Order Form', route: '/forms/material-order' },
      { label: 'Timesheet / Daily Log', route: '/forms/timesheet' },
    ],
  },
  {
    label: 'Maintenance',
    items: [
      { label: 'Maintenance Management', route: '/maintenance' },
      { label: 'Manuals Management', route: '/maintenance?tab=manuals' },
    ],
  },
  {
    label: 'Safety',
    items: [{ label: 'Safety Management', route: '/safety' }],
  },
  {
    label: 'Human Resources',
    items: [{ label: 'HR Management', route: '/hr' }],
  },
  {
    label: 'Inventory',
    items: [{ label: 'Inventory Management', route: '/inventory' }],
  },
  {
    label: 'Other',
    items: [
      { label: 'Reminders', route: '/reminders' },
      { label: 'Bulk Download', route: '/bulk-download' },
    ],
  },
]

export const DASHBOARD_ICON_OPTIONS = [
  'mdi-form-select',
  'mdi-pencil',
  'mdi-pencil-box',
  'mdi-pencil-box-outline',
  'mdi-clipboard-text',
  'mdi-clipboard-text-outline',
  'mdi-clipboard-check',
  'mdi-clipboard-check-outline',
  'mdi-clipboard-list',
  'mdi-clipboard-list-outline',
  'mdi-file-document',
  'mdi-file-document-outline',
  'mdi-file-document-multiple',
  'mdi-file-chart',
  'mdi-file-certificate',
  'mdi-wrench',
  'mdi-wrench-outline',
  'mdi-cog',
  'mdi-cog-outline',
  'mdi-tools',
  'mdi-hammer',
  'mdi-hammer-wrench',
  'mdi-screwdriver',
  'mdi-shield-check',
  'mdi-shield-check-outline',
  'mdi-shield-account',
  'mdi-medical-bag',
  'mdi-hospital-box',
  'mdi-plus-box',
  'mdi-plus-circle',
  'mdi-account-group',
  'mdi-account-group-outline',
  'mdi-account',
  'mdi-account-outline',
  'mdi-account-plus',
  'mdi-account-hard-hat',
  'mdi-account-tie',
  'mdi-briefcase',
  'mdi-briefcase-outline',
  'mdi-package-variant',
  'mdi-package-variant-closed',
  'mdi-truck',
  'mdi-truck-outline',
  'mdi-hard-hat',
  'mdi-warehouse',
  'mdi-factory',
  'mdi-book-open-page-variant',
  'mdi-book-open-variant',
  'mdi-folder',
  'mdi-folder-open',
  'mdi-chart-bar',
  'mdi-chart-line',
  'mdi-chart-pie',
  'mdi-calendar',
  'mdi-calendar-check',
  'mdi-calendar-clock',
  'mdi-bell',
  'mdi-bell-outline',
  'mdi-flag',
  'mdi-flag-outline',
  'mdi-home',
  'mdi-home-outline',
  'mdi-map-marker',
  'mdi-map-marker-outline',
  'mdi-phone',
  'mdi-phone-outline',
  'mdi-email',
  'mdi-email-outline',
  'mdi-camera',
  'mdi-camera-outline',
  'mdi-image',
  'mdi-image-outline',
  'mdi-qrcode',
  'mdi-barcode',
  'mdi-clipboard-pulse',
  'mdi-heart-pulse',
  'mdi-fire',
  'mdi-water',
  'mdi-lightning-bolt',
  'mdi-cash',
  'mdi-credit-card',
  'mdi-cart',
  'mdi-cart-outline',
  'mdi-gavel',
  'mdi-scale-balance',
  'mdi-school',
  'mdi-certificate',
  'mdi-star',
  'mdi-star-outline',
  'mdi-thumb-up',
  'mdi-alert',
  'mdi-alert-circle',
  'mdi-information',
  'mdi-help-circle',
  'mdi-magnify',
  'mdi-link',
  'mdi-link-variant',
  'mdi-download',
  'mdi-upload',
  'mdi-printer',
  'mdi-cloud',
  'mdi-database',
  'mdi-laptop',
  'mdi-cellphone',
  'mdi-tablet',
  'mdi-monitor',
  'mdi-key',
  'mdi-lock',
  'mdi-lock-open',
  'mdi-eye',
  'mdi-eye-outline',
]

export const DEFAULT_PAY_PERIOD = {
  type: 'weekly',
  startDay: '7',
  endDay: '6',
  biweeklyStartDate: '',
  bimonthlyStartDay: 1,
  bimonthlyEndDay: 15,
  lunchMinutes: 45,
  lunchIsPaid: true,
}

export const DEFAULT_STOCK_FORMS = {
  timesheet: true,
  materialOrder: true,
}

export const STOCK_FORM_OPTIONS = [
  {
    key: 'timesheet',
    label: 'Timesheet/ Daily Log',
    description: "Track users' hours and daily progress on site.",
  },
  {
    key: 'materialOrder',
    label: 'Materials Order Form',
    description: 'Order inventory items from site and view orders in PDFs.',
  },
]

export function adminQuickLinkOptions() {
  return ADMIN_QUICK_LINK_OPTIONS
}

export function flattenLinkOptions() {
  return APP_LINK_GROUPS.flatMap((group) => group.items.map((item) => ({ ...item, group: group.label })))
}

export function userDashboardLinkOptions() {
  return flattenLinkOptions().filter((item) => !MANAGEMENT_ROUTES.has(item.route))
}

export function cloneDashboardLinks(links, defaults) {
  const source = Array.isArray(links) && links.length ? links : defaults
  return JSON.parse(JSON.stringify(source))
    .slice(0, 4)
    .map((link) => ({ ...link, enabled: true }))
}

export function cloneUserDashboardLinks(links) {
  return DEFAULT_USER_DASHBOARD_LINKS.map((defaults) => {
    const custom = (Array.isArray(links) ? links : []).find((link) => link.key === defaults.key) || {}
    return {
      ...defaults,
      name: custom.name || defaults.name,
      icon: custom.icon || defaults.icon,
      route: defaults.route,
      enabled: true,
    }
  })
}

export function resolveAdminQuickLinks(props) {
  if (Array.isArray(props?.adminQuickLinks) && props.adminQuickLinks.length) {
    return props.adminQuickLinks.slice(0, 4)
  }
  return DEFAULT_ADMIN_QUICK_LINKS
}

export function resolveUserDashboardLinks(props, themeColor) {
  const saved = Array.isArray(props?.userDashboardLinks) ? props.userDashboardLinks : []
  return DEFAULT_USER_DASHBOARD_LINKS.map((defaults) => {
    const custom = saved.find((link) => link.key === defaults.key) || {}
    return {
      ...defaults,
      name: custom.name || defaults.name,
      icon: custom.icon || defaults.icon,
      route: defaults.route,
      color: themeColor,
    }
  })
}
